import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import BigCard from "../../../general/BigCard";
import styles from "./InfraL2.module.css";
import { InfraStore } from "./InfraStore";
import Leaflet from "./maps/LeafletMap";

function InfraL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);

  const situacaoEstradasValue = InfraStore(
    (state) => state.situacaoEstradasValue,
  );

  const manutencaoEstradasValue = InfraStore(
    (state) => state.manutencaoEstradasValue,
  );

  const setInfraMapImage = InfraStore(
    (state) => state.setInfraMapImage,
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [numeroPropriedades, areaMedia] = await Promise.all([
          Api.getNumeroPropriedadesInfra(
            distrito,
            situacaoEstradasValue,
            manutencaoEstradasValue,
          ),
          Api.getAreaMediaDistritoInfra(
            distrito,
            situacaoEstradasValue,
            manutencaoEstradasValue,
          ),
        ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito, situacaoEstradasValue, manutencaoEstradasValue]);

  return (
    <div className={styles.infraL2}>
      <div className={styles.cards}>
        <div className={styles.card}>
          <BigCard name="Propriedades" value={numeroPropriedades?.value} />
        </div>
        <div className={styles.card}>
          <BigCard
            name={
              <>
                Área Média
                <br />
                (ha)
              </>
            }
            value={areaMedia?.value?.toFixed(2)}
          />
        </div>
      </div>

      <div className={styles.map}>
        <Leaflet distrito={distrito} onImageReady={setInfraMapImage} />
      </div>
    </div>
  );
}

export default InfraL2;
